<div style="position: absolute; right: 10px; z-index: 10" id="fps-wrapper" class="no-print">
  fps: <span id="fps"></span>
</div>
<router-outlet></router-outlet>
<div kendoDialogContainer></div>
